import React from 'react'
import { Installment, Variant } from '../../../../models/Item'
import { getIn, Field } from 'formik'
import { Col, Form, Row } from 'react-bootstrap'
import { formatToPrice } from '../../../../utility/prettifynumber'
import styles from './tablePayments.module.css'

type Props = {
  installmentTerms: Installment[]
  variants: Variant[]
  handleChange: any
  handleBlur: any
  handleTouch: any
  handleError: any
  handleRemove: (index: number) => void
}

const TablePayments = ({
  installmentTerms,
  variants,
  handleChange,
  handleBlur,
  handleTouch,
  handleError
}: Props) => {
  return (
    <>
      {installmentTerms.map((p, index) => {
        const installmentLength = `installmentTerms[${index}].month3`
        const installmentLengthTouched = getIn(handleTouch, installmentLength)
        const installmentLengthError = getIn(handleError, installmentLength)
        const installmentDiscount = `installmentTerms[${index}].month6`
        const installmentDiscountTouched = getIn(
          handleTouch,
          installmentDiscount
        )
        const installmentDiscountError = getIn(handleError, installmentDiscount)
        return (
          <tr key={index} data-testid="installmentTerms">
            <td className="text-center">
              <Col lg="auto">
                <div>
                  <p className={`${styles.smallText} mb-0 pb-0`}>
                    Variant {index + 1}
                  </p>
                </div>
                <div className={`text-primary ${styles.variantText}`}>
                  <b>{formatToPrice(variants[index].price)}</b>
                </div>
              </Col>
            </td>
            <td>
              <Row className="">
                <Col className="ml-0 pl-5 pr-0 mr-0">
                  <Field
                    name={installmentLength}
                    as={Form.Control}
                    type="number"
                    min="0"
                    onChange={handleChange}
                    isInvalid={
                      installmentLengthTouched && !!installmentLengthError
                    }
                  />
                </Col>
                <Col className="ml-0 pl-3 pr-0 mr-0 pt-2 text-dark">
                  {formatToPrice(installmentTerms[index].month3 / 3)} /mo
                </Col>
              </Row>
              <Form.Control.Feedback type="invalid">
                {installmentLengthError}
              </Form.Control.Feedback>
            </td>
            <td>
              <Row>
                <Col className="ml-0 pl-5 pr-0 mr-0">
                  <Field
                    name={installmentDiscount}
                    as={Form.Control}
                    type="number"
                    min="0"
                    onChange={handleChange}
                    isInvalid={
                      installmentDiscountTouched && !!installmentDiscountError
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {installmentDiscountError}
                  </Form.Control.Feedback>
                </Col>
                <Col className="ml-0 pl-3 pr-0 mr-0 pt-2 text-dark">
                  {formatToPrice(installmentTerms[index].month6 / 6)} /mo
                </Col>
              </Row>
            </td>
          </tr>
        )
      })}
    </>
  )
}

export default TablePayments
